import dayjs from "dayjs";
import { trimText } from "../../../../utils/Functions";
import { getDateObject } from "../../../../utils/DateTimeRepository";
import { useTranslation } from "react-i18next";
import { USER } from "../../../../enums/Roles";
const NO_INFO = "NoInfo";

const useGetFinishAppointment = (appointement) => {
  const { t, i18n } = useTranslation();
  const service =
    appointement?.priceList?.translations?.[i18n.language] ||
    appointement?.priceList?.title;

  return getFinishAppointmentDetails(appointement, service, t);
};

function getFinishAppointmentDetails(appointement, service, t) {
  var userName = appointement?.user?.userDetails?.firstName;
  userName = appointement?.user?.userDetails?.lastName
    ? userName + " " + appointement?.user?.userDetails?.lastName
    : userName;

  const details = [
    {
      label: "DateOfAppointment",
      value:
        dayjs(getDateObject(appointement?.startDate)).format("DD/MM/YYYY") ||
        t(NO_INFO),
    },
    {
      label: "TimeOfAppointment",
      value:
        dayjs(getDateObject(appointement?.startDate)).format("HH:mm") +
          " - " +
          dayjs(getDateObject(appointement?.endDate)).format("HH:mm") ||
        t(NO_INFO),
    },
    {
      label: "Service",
      value: service || t(NO_INFO),
    },
  ];

  if (
    appointement &&
    appointement?.user &&
    String(appointement?.user?.role) === USER
  ) {
    details.splice(2, 0, {
      label: "USER",
      value: userName,
    });
  }

  if (appointement && appointement?.pet) {
    details.splice(2, 0, {
      label: "Pet",
      value: trimText(appointement?.pet?.name, 50),
    });
  }

  details.push(
    {
      label: "Description",
      value: appointement?.description || t(NO_INFO),
    },
    {
      label: "Treatment",
      value: appointement?.treatment?.description || t(NO_INFO),
    },
  );

  return details;
}

export { useGetFinishAppointment };
